var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h2',{staticClass:"display-1"},[_vm._v(" 404 ")]),_c('p',[_vm._v("Запрашиваемая страница не найдена.")]),_c('p',[_vm._v(_vm._s(_vm.url))])])}
var staticRenderFns = []

export { render, staticRenderFns }